<div [class.form-card]="!compact" [class.stripe-card]="!compact">
    <p class="welldone-text-gray mb-3" *ngIf="!compact && !updatePaymentMode">
        Inserisci i dati di pagamento per attivare il tuo piano in modo sicuro con Stripe.
    </p>
    <p class="welldone-text-gray mb-3" *ngIf="!compact && updatePaymentMode">
        Aggiorna il metodo di pagamento in modo sicuro con Stripe.
    </p>

    <div class="!flex !items-center !gap-2 !text-sm !text-slate-500" *ngIf="loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>Caricamento area di pagamento...</span>
    </div>

    <div class="mt-2" *ngIf="clientSecret">
        <div #checkoutContainer class="stripe-embedded-container"></div>
    </div>

    <p class="!mb-0 !mt-3 !rounded-xl !bg-red-50 !px-4 !py-3 !text-sm !text-red-700" *ngIf="error">
        {{ error }}
    </p>
</div>
